'use strict'

/* global cf */

import searchFiltersStorage from "./searchFiltersStorage";

/**
 * @module displayRegionName
 */

const CLASS_ACTIV = 'activ'
const CLASS_SEARCH_CAMPING = 'js-search-camping'
const CLASS_REGION_LINK = 'js-region-link'

const ATTRIBUTE_REGION = 'data-region'

const SELECTOR_REGION_NAME = '.js-region-name'

export default {
  /**
   * @description Initialise displayRegionName
   * @returns {undefined}
   */
  init() {
    this.regionsArray = {}
    cf.regionsName.forEach(region => {
      this.regionsArray[region.iso] = {
        name: region.value,
        url: region.url,
        slug: region.slug
      }
    })
    this.bind()
  },

  /**
   * @description Bind events on displayRegionName elements and set href attribute
   * @returns {undefined}
   */
  bind() {
    const regionLinks = document.getElementById(CLASS_SEARCH_CAMPING).getElementsByClassName(CLASS_REGION_LINK)
    regionLinks.bindEvent('mouseenter', this.toggleRegion.bind(this))
    regionLinks.bindEvent('mouseleave', this.toggleRegion.bind(this))
    regionLinks.bindEvent('click', this.clickRegion.bind(this))

    document.querySelectorAll('#js-search-camping ul.region-map-links a')
        .bindEvent('click', this.clickRegion.bind(this))

    Array.prototype.forEach.call(regionLinks, link => {
      link.setAttribute('xlink:href', this.regionsArray[link.getAttribute(ATTRIBUTE_REGION)].url)
      link.setAttribute('data-slug', this.regionsArray[link.getAttribute(ATTRIBUTE_REGION)].slug)
    })
  },

  clickRegion(e) {
    searchFiltersStorage.setValue('region', e.currentTarget.dataset.slug)
  },

  /**
   * @description Toggle CLASS_ACTIV on SELECTOR_REGION_NAME and update or empty it with the
   * hovered region's name
   * @returns {undefined}
   */
  toggleRegion(e) {
    const current = e.currentTarget
    const regionNameContainer = current.parentNode.parentNode.querySelector(SELECTOR_REGION_NAME)

    if (e.type === 'mouseenter') {
      regionNameContainer.innerHTML =
        this.regionsArray[current.getAttribute(ATTRIBUTE_REGION)].name
      regionNameContainer.classList.add(CLASS_ACTIV)
    } else {
      regionNameContainer.classList.remove(CLASS_ACTIV)
      regionNameContainer.innerHTML = ''
    }
  }
}



// WEBPACK FOOTER //
// ./src/apps/Front/private/js/components/displayRegionName.js